import React from 'react';
import { useIntl } from 'react-intl';
import { APPLY_AND_CLOSE_TEXT, APPLY_TEXT, CANCEL_TEXT } from '../../../constants/common-labels.constants';
import { DefaultCloseSubWindowButton } from '../../global/sub-window/common/common-close-sub-window-buttons';
import { observer } from 'mobx-react';
import DefaultButton from '../../global/default-button/default-button';

interface IProps {
    handleSubmit: () => void;
    handleClose: () => void;
    isDisabled: boolean;
    hideApplyAndCloseButton?: boolean;
    closeWhenClickApplyButton?: boolean;
}

const AccountAdminSettingFormFooter = observer((props: IProps): JSX.Element => {
    const {
        handleSubmit,
        handleClose,
        isDisabled,
        hideApplyAndCloseButton,
        closeWhenClickApplyButton
    } = props;
    const intl = useIntl();

    return (
        <div className='buttons-block buttons-block--from-right'>
            {!hideApplyAndCloseButton && (
                <>
                    <DefaultCloseSubWindowButton
                        text={intl.formatMessage(APPLY_AND_CLOSE_TEXT)}
                        modifier={['fat', 'confirm-safe']}
                        onClick={() => handleSubmit()}
                        disabled={isDisabled}
                    />
                </>
            )}
            {closeWhenClickApplyButton ? (
                <DefaultCloseSubWindowButton
                    text={intl.formatMessage(APPLY_TEXT)}
                    modifier={['fat', 'confirm-safe']}
                    onClick={() => handleSubmit()}
                    disabled={isDisabled}
                />
            ) : (
                <DefaultButton
                    text={intl.formatMessage(APPLY_TEXT)}
                    modifier={['fat', 'confirm-safe']}
                    onClick={() => handleSubmit()}
                    disabled={isDisabled}
                />
            )}
            <DefaultCloseSubWindowButton
                text={intl.formatMessage(CANCEL_TEXT)}
                onClick={handleClose}
            />
        </div>
    );
});

export { AccountAdminSettingFormFooter };
